<template>
  <div class="order-dashboard" v-loading="loading">
    <!--      工单分析 work_order_analysis 
             需求分析 work_order_requirement_analysis 
             产能分析 work_order_capacity_analysis  
        -->
    <!-- 查询条件 -->
    <div class="search">
      <el-card
        class="search-card"
        v-if="pageActionBoardNames.includes('work_order_dashboard_page')">
        <div slot="header" class="header">
          <h2>素材工单数据看板</h2>
        </div>
        <div class="content">
          <el-form
            label-position="top"
            label-width="80px"
            :model="form"
            :inline="true">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="form.range_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                @change="handleDateChange"
                @focus="focusDatePicker"
                :clearable="false">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="制作部门" v-if="departmentOptions.length > 0">
              <SelectAll
                :options="departmentOptions"
                v-model="form.material_group"
                @input="getBoardDataList" />
            </el-form-item>
            <el-form-item label="制作人">
              <SelectAll
                :options="peopleOptions"
                v-model="form.material_uid"
                @input="getBoardDataList" />
            </el-form-item>
            <el-form-item label="素材类型">
              <el-select
                v-model="form.material_type"
                placeholder="请选择素材类型"
                @change="getBoardDataList"
                clearable>
                <el-option
                  v-for="item in typeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="游戏类型">
              <SelectAll
                :options="gameTypeOptions"
                v-model="form.project_tag11"
                @input="getBoardDataList" />
            </el-form-item>

            <el-form-item label="产品类型">
              <SelectAll
                :options="app_typeOptions"
                v-model="form.app_type"
                @input="getBoardDataList" />
            </el-form-item>
            <el-form-item label="包体类型">
              <SelectAll
                :options="package_typeOptions"
                v-model="form.package_type"
                @input="getBoardDataList" />
            </el-form-item>
            <el-form-item label="游戏分类">
              <SelectAll
                :options="game_classifyOptions"
                v-model="form.game_classify"
                @input="getBoardDataList" />
            </el-form-item>
            <el-form-item label="游戏题材">
              <SelectAll
                :options="project_tag12Options"
                v-model="form.project_tag12"
                @input="getBoardDataList" />
            </el-form-item>

            <el-form-item label="媒体">
              <SelectAll
                :options="mediaPlatformOptions"
                v-model="form.plat_id"
                @input="getBoardDataList" />
            </el-form-item>
            <el-form-item label=" ">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="btnClickSearch">
                查询
              </el-button>
            </el-form-item>
            <el-form-item label=" ">
              <el-button icon="el-icon-refresh" @click="resetForm">
                重置筛选
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
    <!-- 头部看板 -->
    <HeaderBoard
      :dataObjNum="dataObjNum"
      v-if="
        pageActionBoardNames.includes('work_order_dashboard_page')
      "></HeaderBoard>
    <!-- 动态tabs -->
    <el-tabs v-model="activeTab">
      <el-tab-pane
        v-if="pageActionBoardNames.includes('work_order_analysis')"
        key="work_order_analysis"
        name="work_order_analysis">
        <span slot="label"> <i class="el-icon-document"></i> 工单分析 </span>
      </el-tab-pane>
      <el-tab-pane
        v-if="pageActionBoardNames.includes('work_order_requirement_analysis')"
        key="work_order_requirement_analysis"
        name="work_order_requirement_analysis">
        <span slot="label"> <i class="el-icon-s-data"></i> 需求分析 </span>
      </el-tab-pane>
      <el-tab-pane
        v-if="pageActionBoardNames.includes('work_order_capacity_analysis')"
        key="work_order_capacity_analysis"
        name="work_order_capacity_analysis">
        <span slot="label"> <i class="el-icon-s-custom"></i> 产能分析 </span>
      </el-tab-pane>
      <el-tab-pane
        v-if="pageActionBoardNames.includes('work_order_capacity_board')"
        key="work_order_capacity_board"
        name="work_order_capacity_board">
        <span slot="label"> <i class="el-icon-data-line"></i> 产能看板 </span>
      </el-tab-pane>
      <!-- workOrder_v5 §10：插单看板（新节点 work_order_rush_board·角色勾选才显示） -->
      <el-tab-pane
        v-if="pageActionBoardNames.includes('work_order_rush_board')"
        key="work_order_rush_board"
        name="work_order_rush_board">
        <span slot="label"> <i class="el-icon-alarm-clock"></i> 插单看板 </span>
      </el-tab-pane>
    </el-tabs>
    <div class="tab-content-main">
      <component :is="currentComponent" :form="form"></component>
    </div>
  </div>
</template>
<script>
import { debounce } from "lodash"
import { pageMixin } from "../../mixins/pageMixin"
import HeaderBoard from "./components/HeaderBoard.vue"
import WorkOrderAnalysis from "./workOrderAnalysis/index.vue"
import RequirementsAnalysis from "./requirementsAnalysis/index.vue"
import CapacityAnalysis from "./capacityAnalysis/index.vue"
import CapacityBoard from "./capacityBoard/index.vue"
import RushBoard from "./rushBoard/index.vue"
import SelectAll from "@/components/SelectAll"
import API from "@/api/workOrder/board.js"
export default {
  mixins: [pageMixin],
  components: {
    HeaderBoard,
    WorkOrderAnalysis,
    RequirementsAnalysis,
    CapacityAnalysis,
    CapacityBoard,
    RushBoard,
    SelectAll,
  },
  data() {
    return {
      loading: false,
      form: {
        range_time: [],
        material_group: [],
        material_uid: [],
        material_type: "",
        project_tag11: [],
        plat_id: [],
        app_type: [],
        package_type: [],
        game_classify: [],
        project_tag12: [],
      },
      departmentOptions: [],
      peopleOptions: [],
      typeOptions: [],
      gameTypeOptions: [],
      mediaPlatformOptions: [],
      app_typeOptions: [],
      package_typeOptions: [],
      game_classifyOptions: [],
      project_tag12Options: [],
      activeTab: "work_order_analysis",

      // 看板数量
      dataObjNum: {},
      // 用于存储用户临时选择的第一个日期（在面板打开时使用）
      tempSelectedDate: null,
    }
  },
  computed: {
    // 根据activeTab动态返回对应的组件名
    currentComponent() {
      if (
        this.activeTab === "work_order_analysis" &&
        this.pageActionBoardNames.includes("work_order_analysis")
      ) {
        return "WorkOrderAnalysis"
      } else if (
        this.activeTab === "work_order_requirement_analysis" &&
        this.pageActionBoardNames.includes("work_order_requirement_analysis")
      ) {
        return "RequirementsAnalysis"
      } else if (
        this.activeTab === "work_order_capacity_analysis" &&
        this.pageActionBoardNames.includes("work_order_capacity_analysis")
      ) {
        return "CapacityAnalysis"
      } else if (
        this.activeTab === "work_order_capacity_board" &&
        this.pageActionBoardNames.includes("work_order_capacity_board")
      ) {
        return "CapacityBoard"
      } else if (
        this.activeTab === "work_order_rush_board" &&
        this.pageActionBoardNames.includes("work_order_rush_board")
      ) {
        return "RushBoard"
      }
    },
    // 使用计算属性来动态生成日期选择器选项，以实现实时限制
    datePickerOptions() {
      const that = this
      return {
        onPick: ({ minDate, maxDate }) => {
          if (minDate && !maxDate) {
            // 存储第一个选择的日期
            that.tempSelectedDate = minDate
          } else if (!minDate && !maxDate) {
            // 当清除选择时
            that.tempSelectedDate = null
          }
        },
        disabledDate(time) {
          // 如果已经临时选择了第一个日期，则限制前后100天
          if (that.tempSelectedDate) {
            const start = new Date(that.tempSelectedDate)
            start.setDate(start.getDate() - 99)
            const end = new Date(that.tempSelectedDate)
            end.setDate(end.getDate() + 99)
            return (
              time.getTime() < start.getTime() || time.getTime() > end.getTime()
            )
          }
          return false
        },
        // 快捷选择配置
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date()
              end.setDate(end.getDate() - 1)
              const start = new Date(end)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近7日",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 6)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30日",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(start.getDate() - 29)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              const day = start.getDay() || 7 // 转换周日为7
              start.setDate(start.getDate() - day + 1) // 周一
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const end = new Date()
              const start = new Date(end.getFullYear(), end.getMonth(), 1)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "本季度",
            onClick(picker) {
              const end = new Date()
              const quarter = Math.floor(end.getMonth() / 3)
              const start = new Date(end.getFullYear(), quarter * 3, 1)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    pageActionBoardNames() {
      return this.collectNames(this.pageAction)
    },
  },
  watch: {
    // 权限就绪后（pageAction 异步填充）动态把 activeTab 落到首个有权限的 tab，
    // 避免「无工单分析权限、仅有产能看板权限」的用户进页面落到硬编码默认 tab 而白屏
    pageActionBoardNames: {
      immediate: true,
      handler() {
        this.initActiveTab()
      },
    },
  },
  mounted() {
    // 设置默认选择最近30天
    this.setDefaultDateRange()
    this.getFilterSelectList()
  },
  methods: {
    // 动态选首个有权限的 tab：当前 activeTab 无权限时落到第一个有权限的；有权限则保留用户选择
    initActiveTab() {
      const order = [
        "work_order_analysis",
        "work_order_requirement_analysis",
        "work_order_capacity_analysis",
        "work_order_capacity_board",
        "work_order_rush_board",
      ]
      const allowed = order.filter((n) => this.pageActionBoardNames.includes(n))
      if (!allowed.length) return
      if (!allowed.includes(this.activeTab)) {
        this.activeTab = allowed[0]
      }
    },
    // 重置筛选
    resetForm() {
      this.form = {
        range_time: [],
        material_group: [],
        material_uid: [],
        material_type: "",
        project_tag11: [],
        plat_id: [],
      }
      this.setDefaultDateRange()
      this.getBoardDataList()
    },
    // 设置默认日期范围（最近30天）
    setDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 29)

      // 格式化日期为字符串格式
      const formatDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
      }

      this.form.range_time = [formatDate(start), formatDate(end)]
      // 同步设置tempSelectedDate为默认的第一个日期
      // this.tempSelectedDate = start
    },
    // 处理日期变化事件
    handleDateChange(value) {
      // 当用户清除选择时，重置临时选择的日期
      if (!value || value.length === 0) {
        this.tempSelectedDate = null
      }
      this.getBoardDataList()
    },
    focusDatePicker() {
      this.tempSelectedDate = null
    },
    // 下拉框数据
    getFilterSelectList() {
      API.getWorkOrderSearchConfig().then((res) => {
        if (res.code === 200) {
          this.typeOptions = res.data.material_type
          this.gameTypeOptions = res.data.project_tag11
          this.mediaPlatformOptions = res.data.plat
          this.app_typeOptions = res.data.app_type
          this.package_typeOptions = res.data.package_type
          this.game_classifyOptions = res.data.game_classify
          this.project_tag12Options = res.data.project_tag12
        }
      })
      // 制作部门下拉数据
      API.getWorkOrderSearchList({ search_type: "material_group" }).then(
        (res) => {
          if (res.code === 200) {
            this.departmentOptions = res.data.list
          }
        }
      )
      // 制作人下拉数据
      API.getWorkOrderSearchList({ search_type: "production_user" }).then(
        (res) => {
          if (res.code === 200) {
            this.peopleOptions = res.data.list
          }
        }
      )
      this.getBoardDataList()
    },
    getBoardDataList: debounce(function () {
      this.loading = true
      let params = {
        ...this.form,
        range_time:
          this.form.range_time?.length > 0
            ? this.form?.range_time.join("/")
            : "",
      }

      // 看板数量
      API.getWorkOrderDataNum(params).then((res) => {
        if (res.code === 200) {
          this.loading = false
          this.dataObjNum = res.data
        }
      })
    }, 500),
    btnClickSearch() {
      let obj = JSON.parse(JSON.stringify(this.form))
      this.form = {
        range_time: [],
        material_group: [],
        material_uid: [],
        material_type: "",
        project_tag11: [],
        plat_id: [],
      }
      this.form = obj
      this.getBoardDataList()
    },
    // 收集权限数据中第一级对象的name和func数组中每个对象的name
    collectNames(permissionData) {
      // 存储收集到的所有name
      const nameList = []

      // 检查数据是否为数组
      if (!Array.isArray(permissionData)) {
        return nameList
      }

      // 遍历数据数组
      permissionData.forEach((permission) => {
        // 如果当前项有name属性，添加到结果数组
        if (permission && permission.name) {
          nameList.push(permission.name)
        }

        // 如果当前项有func数组，提取每个func项的name属性
        if (permission && Array.isArray(permission.func)) {
          permission.func.forEach((funcItem) => {
            if (funcItem && funcItem.name) {
              nameList.push(funcItem.name)
            }
          })
        }
      })

      return nameList
    },
  },
}
</script>

<style scoped lang="scss">
.order-dashboard {
  width: 100%;
  height: 100%;
  // margin: px;
  overflow-y: auto;

  .search-card {
    border-radius: 10px;
    ::v-deep(.el-card__header) {
      border-bottom: 0 !important;
      padding: 15px;
    }
    ::v-deep(.el-card__body) {
      padding-top: 0px;
      .el-form {
        .el-form-item {
          margin-bottom: 10px !important;
        }
        .el-form-item__label {
          line-height: 0 !important;
          color: #6f7584;
        }
      }
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .content {
      .el-form {
        ::deep(.el-form-item) {
          margin-bottom: 0 !important;
        }
        ::deep(.el-form-item__label) {
          line-height: 0 !important;
        }
      }
    }
  }
  .el-tabs {
    padding-left: 20px;
    background: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  :deep(.el-tabs__header) {
    margin-bottom: 0;
  }
  .tab-content-main {
    margin-top: 20px;
  }
}
</style>
